import {ModalV3} from "./ModalV3";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts file
/**
 * Class based version of initial modalV2
 */
class GridModalV3 extends ModalV3 {
	/** @var {GridModalV3Defs.Config} */
	config;

	init() {
		// Init tree
		this.initGridView();

		// By default call init function from config if set
		if (this.config.init) {
			this.config.init(this);
		}
	}

	initGridView() {

	}

	display(firstTime) {
		super.display(firstTime);

		// Focus search input after modal is displayed
		setTimeout(() => {
			this.focusSearchInput();
		}, 512)
	}

	getSearchInput() {
		return this.modalContainer.querySelector(
			'input[name="search"]'
		);
	}

	focusSearchInput() {
		const searchInputElement = this.getSearchInput();

		if (searchInputElement) {
			searchInputElement.focus()
		}
	}
}

export {GridModalV3}
